import Vue from "vue";
import "./plugins/axios";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import StoreMixin from "./mixins/store.mixin";
import VueAnalytics from "vue-analytics";
import visibility from "./features/visibility";
import feature from "vue-feature-toggle";
import LogRocket from "logrocket";

if (process.env.ENVIRONMENT !== "development")
  LogRocket.init("uotsmx/dealermanager");

Vue.config.productionTip = false;
Vue.mixin(StoreMixin);

router.beforeEach((to, from, next) => {
  if (to.name == "callback" || to.name == "login") {
    // check if "to"-route is "callback" and allow access
    next();
  } else if (store.getters["auth/isAuthenticated"]) {
    // if authenticated allow access
    next();
  } else {
    // trigger auth0 login
    next("/login");
  }
});
import wysiwyg from "vue-wysiwyg";
Vue.use(wysiwyg, {
  image: {
    uploadURL: "hhtps://" + process.env.API + "/orders/UploadDealerFiles",
    dropzoneOptions: {},
  },
});

const isProd = process.env.NODE_ENV === "production";

Vue.use(VueAnalytics, {
  id: process.env.GOOGLE,
  router,
  autoTracking: {
    exception: true,
    //screenview: true
  },
  debug: {
    enabled: false,
    sendHitTask: true, //isProd
  },
});

// feature.requiredVisibility(function(rule) {
//   return typeof visibility[rule.name] == "undefined"
//     ? true
//     : visibility[rule.name];
// });

feature.requiredVisibility((rule) => {
  let visible =
    typeof visibility[rule.name] == "undefined" ? true : visibility[rule.name];
  return visible;
});
// feature.visibility("default", function() {
//   return true;
// });
Vue.component("feature", feature);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
